import { Component, Input, OnInit } from "@angular/core";
import { firstValueFrom, forkJoin, lastValueFrom } from "rxjs";
import {
  Game,
  HomeRanks,
  RoadRanks,
  ScorePronos,
  ScoringPosition,
  Standings,
  StandingsOldModel,
  TeamStats,
} from "src/app/models/games/games.models";
import { MathsService } from "src/app/services/maths/maths-service";
import { StatsService } from "src/app/services/stats/stats-service";

@Component({
  selector: "app-stats-analyser",
  templateUrl: "./stats-analyser.component.html",
  styleUrls: ["./stats-analyser.component.scss"],
})
export class StatsAnalyserComponent implements OnInit {
  @Input() game: Game;
  roadTeamStats: TeamStats;
  homeTeamStats: TeamStats;
  homeScoringPosition: ScoringPosition;
  roadScoringPosition: ScoringPosition;
  @Input() gameScoring: ScorePronos;
  @Input() homeStanding: Standings;
  @Input() roadStanding: Standings;
  @Input() homeRanks: HomeRanks;
  @Input() roadRanks: RoadRanks;
  @Input() date: string;

  constructor(
    private statsService: StatsService,
    private mathsService: MathsService
  ) {}

  async ngOnInit(): Promise<void> {
    const [roadTeamStats, homeTeamStats] = await lastValueFrom(
      forkJoin([
        this.statsService.getTeamStats(
          this.statsService.getCorrectName(this.game.roadTeam),
          this.date
        ),
        this.statsService.getTeamStats(
          this.statsService.getCorrectName(this.game.homeTeam),
          this.date
        ),
      ])
    );

    const [roadScoringPosition, homeScoringPosition] = await lastValueFrom(
      forkJoin([
        this.statsService.getScoringPosition(
          this.statsService.getCorrectName(this.game.roadTeam)
        ),
        this.statsService.getScoringPosition(
          this.statsService.getCorrectName(this.game.homeTeam)
        ),
      ])
    );

    this.homeScoringPosition = homeScoringPosition;
    this.roadScoringPosition = roadScoringPosition;

    this.roadTeamStats = roadTeamStats;
    this.homeTeamStats = homeTeamStats;

    await this.statsService.roadStatsTrigger.subscribe((points) => {
      //  await this.statsService.roadStatsTrigger.subscribe((points) => {
      console.log("points", points);
      console.log("aso --------", this.gameScoring.averageRoadPoints);

      this.gameScoring.averageRoadPoints += points;
      document.getElementById("road-ppg").textContent =
        this.gameScoring.averageRoadPoints.toString();
      // this.roadTeamStats.roadTraditional[0].points.toString();
    });

    await this.statsService.homeStatsTrigger.subscribe((points) => {
      console.log("aso --------", this.gameScoring.averageHomePoints);

      this.gameScoring.averageHomePoints += points;
      document.getElementById("home-ppg").innerHTML =
        this.gameScoring.averageRoadPoints.toString();
    });
  }

  biggerRank(roadValue: number, homeValue: number) {
    if (homeValue > roadValue) {
      return this.game.homeTeam;
    } else {
      return this.game.roadTeam;
    }
  }

  biggerRankInverted(
    roadValue: number,
    homeValue: number,
    completeName = false
  ) {
    if (homeValue > roadValue) {
      return completeName ? this.game.roadTeam + " (EXT.)" : this.game.roadTeam;
    } else {
      return completeName ? this.game.homeTeam + " (DOM.)" : this.game.homeTeam;
    }
  }

  setAverage(v1: number, v2: number) {
    return this.mathsService.setAverage(v1, v2);
  }

  getWinner(
    v1: number,
    v2: number,
    home: string,
    road: string,
    printLocation = false
  ) {
    return this.mathsService.getWinner(v1, v2, home, road, printLocation);
  }

  isOvertime(v1: number, v2: number) {
    if (Math.abs(v1 - v2) < 2) {
      return "Overtime";
    } else if (Math.abs(v1 - v2) > 4) {
      return "EasyWin?";
    } else {
      return "";
    }
  }

  isGoodProno(
    roadScore: number,
    homeScore: number,
    roadTeam: string,
    homeTeam: string,
    pronoWinner: string
  ) {
    let realWinner = +roadScore > +homeScore ? roadTeam : homeTeam;
    if (!roadScore) {
      return "white";
    }
    if (pronoWinner == realWinner) {
      return "green";
    } else {
      return "red";
    }
  }

  isGoodPronoRank(
    roadScore: number,
    homeScore: number,
    roadRank: number,
    homeRank: number,
    roadTeam: string,
    homeTeam: string,
    pronoWinner: string
  ) {
    let realWinner = +roadScore > +homeScore ? roadTeam : homeTeam;
    if (!roadScore) {
      return "white";
    }
    if (pronoWinner == realWinner) {
      return "green";
    } else {
      return "red";
    }
  }
}
